import React from 'react';

const Review = () => {
  // Sample testimonials data
  const testimonials = [
    {
      id: 1,
      name: 'David Wilson',
      role: 'Personal Trainer',
      image: 'https://randomuser.me/api/portraits/men/22.jpg',
      quote:
        'The AI meal tracking feature is incredibly accurate and saves me so much time. This app has become an essential part of my daily routine.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      role: 'Fitness Enthusiast',
      image: 'https://randomuser.me/api/portraits/women/32.jpg',
      quote:
        "TheChamps has completely transformed my approach to fitness. The small wins approach made all the difference in staying consistent. I've never felt better!",
      rating: 5,
    },
    {
      id: 3,
      name: 'Michael Chen',
      role: 'Marathon Runner',
      image: 'https://randomuser.me/api/portraits/men/45.jpg',
      quote:
        'As someone who struggled with consistency, this app has been a game-changer. The momentum tracking feature keeps me motivated every day.',
      rating: 5,
    },
    {
      id: 4,
      name: 'Emily Rodriguez',
      role: 'Yoga Instructor',
      image: 'https://randomuser.me/api/portraits/women/68.jpg',
      quote:
        "I love how TheChamps focuses on building sustainable habits rather than quick fixes. It's helped me maintain my fitness routine even during busy periods.",
      rating: 4,
    },
  ];

  // Function to render stars based on rating
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        className={`w-5 h-5 ${
          index < rating ? 'text-yellow-500' : 'text-gray-600'
        }`}
        fill='currentColor'
        viewBox='0 0 20 20'
      >
        <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
      </svg>
    ));
  };

  return (
    <section
      className='py-20 bg-black text-white'
      id='review'
    >
      <div className='container mx-auto px-4 max-w-6xl'>
        <div className='text-center mb-16'>
          <h2 className='text-3xl md:text-4xl font-bold mb-4'>
            Our Community Says
          </h2>
          <p className='text-lg text-text-submain max-w-2xl mx-auto'>
            Be one of the first to transform your life with TheChamps
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className='bg-secondary rounded-xl p-6 shadow-lg border border-tertiary hover:border-yellow-500 transition-all duration-300'
            >
              <div className='flex items-center mb-4'>
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className='w-12 h-12 rounded-full mr-4 border-2 border-yellow-500'
                />
                <div>
                  <h3 className='font-bold text-lg'>{testimonial.name}</h3>
                </div>
              </div>

              <div className='flex mb-4'>{renderStars(testimonial.rating)}</div>

              <p className='text-text-submain italic'>"{testimonial.quote}"</p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className='mt-16 flex justify-between items-center gap-6 max-w-2xl mx-auto'>
          <div className='text-center'>
            <div className='text-3xl md:text-4xl font-bold text-accent mb-2'>
              1.5M+
            </div>
            <div className='text-text-submain'>Total Community</div>
          </div>
          <div className='text-center'>
            <div className='text-3xl md:text-4xl font-bold text-accent mb-2'>
              4.9/5
            </div>
            <div className='text-text-submain'>App Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Review;
